import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PrivateRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-center mt-5">Carregando...</div>;
  }

  // 🔒 se não estiver logado, redireciona para login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // ✅ se estiver logado, renderiza as rotas filhas
  return <Outlet />;
}
